<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container" :class="{'full-width': isFullWidth}">
        <card class="card-profile mt--300" no-body shadow>
          <div class="px-4">

            <div v-if="!showPage" class="text-center mt-5">
              <h3>یادداشت امن</h3>
              <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>راهی برای ذخیره امن یادداشت در فضای
                ابری
              </div>

              <div class="h6 mt-4" style="text-align: right">شناسه صفحه</div>
              <base-input class="mb-4">
                <input v-model="pageName" class="form-control form-control-alternative" name="name"
                       placeholder="شناسه صفحه" type="text"/>
                <div class="small" style="color: #949494; text-align: right; margin-top: 4px">
                  شناسه صفحه نامی یکتا برای دسترسی به یادداشت شماست. در صورتی که شناسه صفحه‌ای وارد کنید که از قبل وجود
                  نداشته است برای شما یک صفحه جدید با آن نام برای شما ایجاد می‌شود.
                </div>

              </base-input>

              <div class="h6 mt-4" style="text-align: right">کلید رمزنگاری (محرمانه)</div>
              <base-input class="mb-4">
                <input v-model="password" class="form-control form-control-alternative" name="password"
                       placeholder="کلید رمزنگاری" type="password"/>
                <div class="small" style="color: #949494; text-align: right; margin-top: 4px">
                  کلید رمزنگاری عبارتی محرمانه است که با آن یادداشت شما رمزنگاری می‌شود. این کلید برای سرور ارسال نمی‌شود.
                </div>

              </base-input>

              <br>

              <base-alert v-if="showError" icon="ni ni-support-16" type="danger">
                <span slot="text"><strong>خطا! </strong>{{ error }}</span>
              </base-alert>

              <base-button type="primary" @click="openPage">ادامه</base-button>
              <div/>
              <br>

            </div>


            <div v-if="showPage" class="text-center mt-5">
              <h3>یادداشت امن</h3>
              <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>راهی برای ذخیره امن یادداشت در فضای
                ابری
              </div>

              <div style="background: #634eaa; display: flex; justify-content: center; align-items: center; padding: 4px 0 4px 0; color: white; flex-wrap: wrap">
                <input type="checkbox" id="is-ltr" v-model="isLTR" />
                <label for="is-ltr" style="margin: 0 4px 0 14px;">LTR</label>

                <input type="checkbox" id="is-full-width" v-model="isFullWidth" />
                <label for="is-full-width" style="margin: 0 4px 0 14px;">تمام عرض</label>

                <button class="btn" style="margin: 2px 0 2px 0; padding: 2px 8px 2px 8px" @click="openPage">رفرش</button>

              </div>

              <div class="h6 mt-4" style="text-align: right">یادداشت خود را وارد کنید</div>

              <base-input class="mb-4">
                <textarea v-model="text" class="form-control form-control-alternative" :class="{ltr: isLTR}" cols="80"
                          name="name" placeholder="متن یادداشت" rows="6"></textarea>
              </base-input>

              <br>

              <base-alert v-if="showError" icon="ni ni-support-16" type="danger">
                <span slot="text"><strong>خطا! </strong>{{ error }}</span>
              </base-alert>

              <base-button type="neutral" @click="goHome">بستن</base-button>
              <base-button type="primary" @click="savePage">ذخیره</base-button>

              <div/>
              <br>

            </div>
          </div>
        </card>
        <div style="margin-top: 48px">
          <h4 class="text-primary">امنیت و حریم خصوصی</h4>
          <p>
            این ابزار طبق استراتژی اعتماد صفر یا Zero Trust با تلاش برای حفظ بالاترین سطح حریم خصوصی طراحی شده است. نه
            تنها هیچ اطلاعاتی برای شناسایی هویت کاربر ذخیره نمی‌شود بلکه حتی اطلاعات ضروری از جمله متن پیام و کلمه‌عبور
            با الگوریتم‌های رمزنگاری مدرن از جمله AES-256 و SHA-256 که مورد تایید استاندارد بین‌المللی مورد تایید NIST
            آمریکا (حتی در سطح نظامی) هستند رمزگذاری شده‌اند. متن پیام شما به صورت رمزنگاری سر تا سر یا همان End-to-End
            ذخیره می‌شود و پیام‌های ذخیره شده توسط هیچکس به جز شخصی که کلید محرمانه رمزنگاری را دراختیار دارد قابل
            رمزگشایی نیست! کلید محرمانه شما برای سرور ارسال نمی‌شود و از آن‌جایی که کلید محرمانه فقط در اختیار شما است
            حتی ما امکان بازیابی آن یا رمزگشایی و خواندن پیام‌ها را نداریم.
          </p>
          <p>
            از طرفی برای امنیت بیش‌تر مسیر ارتباطی شما تا سرور، از پروتکل SSL استفاده شده است.
          </p>
          <p>
            جهت امنیت بیش‌تر در این ابزار، هیچ داده‌ای در حافظه داخلی مرورگر، کش، کوکی و یا نشست ذخیره نمی‌شود.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Inputs from "./components/Inputs";
import BaseDropdown from "../components/BaseDropdown";
import axios from "axios";

/**
 * Secure Hash Algorithm (SHA256)
 * http://www.webtoolkit.info/
 * Original code by Angel Marin, Paul Johnston
 **/

function SHA256(s) {
  var chrsz = 8;
  var hexcase = 0;

  function safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return (msw << 16) | (lsw & 0xFFFF);
  }

  function S(X, n) {
    return (X >>> n) | (X << (32 - n));
  }

  function R(X, n) {
    return (X >>> n);
  }

  function Ch(x, y, z) {
    return ((x & y) ^ ((~x) & z));
  }

  function Maj(x, y, z) {
    return ((x & y) ^ (x & z) ^ (y & z));
  }

  function Sigma0256(x) {
    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
  }

  function Sigma1256(x) {
    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
  }

  function Gamma0256(x) {
    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
  }

  function Gamma1256(x) {
    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
  }

  function core_sha256(m, l) {
    var K = new Array(0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0xFC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x6CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2);
    var HASH = new Array(0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A, 0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19);
    var W = new Array(64);
    var a, b, c, d, e, f, g, h, i, j;
    var T1, T2;

    m[l >> 5] |= 0x80 << (24 - l % 32);
    m[((l + 64 >> 9) << 4) + 15] = l;

    for (var i = 0; i < m.length; i += 16) {
      a = HASH[0];
      b = HASH[1];
      c = HASH[2];
      d = HASH[3];
      e = HASH[4];
      f = HASH[5];
      g = HASH[6];
      h = HASH[7];

      for (var j = 0; j < 64; j++) {
        if (j < 16) W[j] = m[j + i];
        else W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);

        T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);
        T2 = safe_add(Sigma0256(a), Maj(a, b, c));

        h = g;
        g = f;
        f = e;
        e = safe_add(d, T1);
        d = c;
        c = b;
        b = a;
        a = safe_add(T1, T2);
      }

      HASH[0] = safe_add(a, HASH[0]);
      HASH[1] = safe_add(b, HASH[1]);
      HASH[2] = safe_add(c, HASH[2]);
      HASH[3] = safe_add(d, HASH[3]);
      HASH[4] = safe_add(e, HASH[4]);
      HASH[5] = safe_add(f, HASH[5]);
      HASH[6] = safe_add(g, HASH[6]);
      HASH[7] = safe_add(h, HASH[7]);
    }
    return HASH;
  }

  function str2binb(str) {
    var bin = Array();
    var mask = (1 << chrsz) - 1;
    for (var i = 0; i < str.length * chrsz; i += chrsz) {
      bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << (24 - i % 32);
    }
    return bin;
  }

  function Utf8Encode(string) {
    string = string.replace(/\r\n/g, '\n');
    var utftext = '';

    for (var n = 0; n < string.length; n++) {

      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }

    }

    return utftext;
  }

  function binb2hex(binarray) {
    var hex_tab = hexcase ? '0123456789ABCDEF' : '0123456789abcdef';
    var str = '';
    for (var i = 0; i < binarray.length * 4; i++) {
      str += hex_tab.charAt((binarray[i >> 2] >> ((3 - i % 4) * 8 + 4)) & 0xF) +
          hex_tab.charAt((binarray[i >> 2] >> ((3 - i % 4) * 8)) & 0xF);
    }
    return str;
  }

  s = Utf8Encode(s);
  return binb2hex(core_sha256(str2binb(s), s.length * chrsz));
}

export default {
  components: {
    Inputs,
    BaseDropdown
  },
  data() {
    return {
      showPage: false,
      pageName: '',
      password: '',
      text: '',
      showError: false,
      error: '',
      isLTR: false,
      isFullWidth: false,
    }
  },
  methods: {
    goHome() {
      this.$router.go(0)
    },
    openPage() {
      let canContinue = true;
      this.showError = false

      if (this.pageName === '') {
        this.error = 'شناسه صفحه نمی‌تواند خالی باشد'
        this.showError = true
        canContinue = false;
      } else if (this.password === '') {
        this.error = 'گذرواژه نمی‌تواند خالی باشد'
        this.showError = true
        canContinue = false;
      }

      if (canContinue) {

        const formData = new FormData()
        formData.append('pgn', this.pageName)
        formData.append('pgp', SHA256("Fc5iD!i!pKJEWzw*" + this.pageName + this.password))

        const headers = {'Content-Type': 'multipart/form-data'}
        axios.post(`${process.env.VUE_APP_API_ROOT}/open-page_v1`, formData, {headers})
            .then(res => {
              if (res.status === 200) {
                if (res.data.r === 1 || res.data.r === 2) {
                  //this.$router.push({name: 'share', params: {hash: res.data.h}})
                  //alert("Next Step");
                  let plaintext = CryptoJS.AES.decrypt(res.data.c, this.password).toString(CryptoJS.enc.Utf8);
                  //this.text = this.fromBinary(res.data.c);
                  this.text = plaintext;

                  this.showPage = true;
                } else if (res.data.r === 3) {
                  this.error = 'گذرواژه نادرست است.'
                  this.showError = true
                } else {
                  this.error = 'متاسفانه خطایی غیرمنتظره رخ داد'
                  this.showError = true
                }
              } else {
                this.error = 'متاسفانه خطایی رخ داد'
                this.showError = true
              }
            })

      }
    },
    savePage() {

      let encrypted = '' + CryptoJS.AES.encrypt(this.text, this.password);

      /*var decrypted = CryptoJS.AES.decrypt(encrypted, secret);

      if(decrypted.toString(CryptoJS.enc.Utf8)==plaintext){
        $('#outputCheck').text("Encrypted successfuly");
      } else {
        $('#outputCheck').text("Something went wrong!");

      }*/
      //$('#result').text(decrypted.toString(CryptoJS.enc.Utf8));

      const formData = new FormData()

      formData.append('pgn', this.pageName)
      formData.append('pgp', SHA256("Fc5iD!i!pKJEWzw*" + this.pageName + this.password))
      formData.append('pgc', encrypted)

      const headers = {'Content-Type': 'multipart/form-data'}
      axios.post(`${process.env.VUE_APP_API_ROOT}/save-page_v1`, formData, {headers})
          .then(res => {
            if (res.status === 200) {
              if (res.data.r === 1) {
                this.showError = false
                alert("ذخیره شد");
              } else if (res.data.r === 2) {
                this.error = 'گذرواژه نادرست است.'
                this.showError = true
              } else {
                this.error = 'متاسفانه خطایی غیرمنتظره رخ داد'
                this.showError = true
              }
            } else {
              this.error = 'متاسفانه خطایی رخ داد'
              this.showError = true
            }
          })


    },

    // convert a Unicode string to a string in which
// each 16-bit unit occupies only one byte
    toBinary(string) {
      const codeUnits = new Uint16Array(string.length);
      for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = string.charCodeAt(i);
      }
      return btoa(String.fromCharCode(...new Uint8Array(codeUnits.buffer)));
    },
    fromBinary(encoded) {
      const binary = atob(encoded);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return String.fromCharCode(...new Uint16Array(bytes.buffer));
    },

    digestMessage(message) {
      const msgUint8 = new TextEncoder().encode(message);                           // encode as (utf-8) Uint8Array
      const hashBuffer = crypto.subtle.digest('SHA-256', msgUint8);           // hash the message
      const hashArray = Array.from(new Uint8Array(hashBuffer));                     // convert buffer to byte array
      const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
      return hashHex;
    }


  }
}

</script>

<style>

.ltr {
  direction: ltr;
}

.full-width {
  max-width: 100% !important;
}

</style>
